import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    error: null,
    data: {},
};

export const resetPasswordReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_RESET_PASSWORD_START:
            return {
                ...state,
                loading: true,
            };
        case types.POST_RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case types.POST_RESET_PASSWORD_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
